/** Limite de upload na área administrativa de sinistro. */
export const ADMIN_SINISTRO_MAX_FILE_SIZE_BYTES = 200 * 1024 * 1024;

/** Rótulo exibido em telas e mensagens de erro. */
export const ADMIN_SINISTRO_MAX_FILE_SIZE_LABEL = '200MB';
